<div class="row" *ngIf="loading">
  <mat-progress-bar mode="indeterminate" color="primary"></mat-progress-bar>
</div>

<div class="container-fluid accordion-container">
  <div class="container">
    <mat-accordion class="accordion" multi>
      <mat-expansion-panel>
        <mat-expansion-panel-header class="container px-0">
          <mat-panel-title>
            <span class="index">1</span>
            {{ "generic.details" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <app-ckm-simulation-details *ngIf="simulation" [simulation]="simulation" />
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>

<div class="container-fluid accordion-container">
  <div class="container">
    <mat-accordion class="accordion" multi>
      <mat-expansion-panel expanded>
        <mat-expansion-panel-header class="container px-0">
          <mat-panel-title>
            <span class="index">2</span>
            {{ "generic.maps" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>

        <app-ckm-simulation-maps [maps]="simulation?.maps || []"/>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>

<div class="buttons-container container py-4">
  <button class="button-primary float-left" mat-button [routerLink]="['/projects/' + simulation?.organization_project_id]"
          routerLinkActive="router-link-active">
    <i class="icon-Backward-arrow-small"></i>
    {{ 'generic.buttons.go-to-simulation' | translate }}
  </button>
</div>
